import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-menu-anonymous',
  templateUrl: './nav-menu-anonymous.component.html',
  styleUrls: ['./nav-menu-anonymous.component.scss'],
  standalone: false
})
export class NavMenuAnonymousComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
